<input
  [(ngModel)]="value"
  type="text"
  #control
  #model="ngModel"
  name="{{ name }}"
  id="{{ name }}"
  placeholder="{{ placeholder }}"
  [required]="required"
  [min]="min"
  [max]="max"
  [readonly]="readonly"
  (keydown)="onKeyDown($event)"
  (blur)="onBlurred($event)"
  (focus)="isEditActive = true; onFocused($event)"
  [disabled]="disabled"
  class="form-control form-control-solid"
  [ngClass]="{
    'is-invalid': model && model.touched && model.invalid,
    'marked-as-invalid': highlightAsInvalid
  }"
/>

@if (model.errors?.required) {
  <div class="invalid-feedback d-block">
    This field is required
  </div>
}
@if (model.errors?.min) {
  <div class="invalid-feedback d-block">
    Value cannot be less than {{ min | currency }}
  </div>
}
@if (model.errors?.max) {
  <div class="invalid-feedback d-block">
    Value cannot be greater than {{ max | currency }}
  </div>
}
